"use strict";

var PropTypes = require("prop-types");

var PledgeActions = require("../actions/PledgeActions");
var PledgeStore = require("../stores/PledgeStore");

var Frequency = require("../commonComponents/Frequency");

class DonationFrequency extends React.Component {
	render() {
		return (
			<Frequency
				{...this.props}
				thisArg={this}
				beginningComponentName="Pledge"
				tangibleActions={PledgeActions}
				tangibleStore={PledgeStore}
				tangibleType="pledge"
				displayCodeProperty="PledgeCode"
				reactComponentCategory="PledgeFrequencyComponents"
			/>
		);
	}
}

DonationFrequency.defaultProps = {
	type: "button",
	theme: "0",
	isCustomTheme: false
};

DonationFrequency.propTypes = {
	isDesignMode: PropTypes.bool, //can do .isRequired
	pledge: PropTypes.object,
	frequencies: PropTypes.array,
	type: PropTypes.oneOf(["button", "radio", "dropdown"]),
	context: PropTypes.string,
	theme: PropTypes.string,
	isCustomTheme: PropTypes.bool,
	childClass: PropTypes.string,
	dataComponentId: PropTypes.string,
	dataNestedId: PropTypes.string,
	dataRepeatedId: PropTypes.string
};

module.exports = DonationFrequency;
